export function responseResolve(response) {
  if (response.data.code === 401) localStorage.removeItem('token')
  return Promise.resolve(response.data)
}
